export default "__VITE_ASSET__DYM6$$Y5__"